// matches polyfill
// from: https://developer.mozilla.org/en-US/docs/Web/API/element/matches
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.webkitMatchesSelector;
}
